import React, { ReactNode, useContext, useMemo, useRef, useState } from 'react';
import ValueField from '../connectedForm/ValueField';
import componentStyles from 'styles/partials/_image-selector.css';
import inputStyles from 'styles/partials/_baseinput.css';
import { appActions } from '../../state/modules/app';
import { mdiLoading } from '@mdi/js';
import Icon from '@mdi/react';
import { serviceActions } from '../../state/modules/service';
import { AlertType } from '../../graphql/schema/p4types';
import { useDispatch } from 'react-redux';
import ConnectedFormContext from '../Context/ConnectedFormContext';

const FileSelector = ({
  endPoint: endPointFromProps,
  excludeId,
  hiddenClass,
  label,
  message,
  onBlur,
  removeFileOption,
  value,
}: {
  endPoint: string;
  excludeId?: boolean;
  hiddenClass?: boolean;
  label?: string;
  message?: any; //Not convinced this is used - Used to display errors below the control.
  onBlur: (value: string) => void;
  removeFileOption?: boolean;
  value: string;
}) => {
  const connectedForm = useContext(ConnectedFormContext);

  const styles: { [key: string]: any } = {};
  Object.assign(styles, componentStyles, inputStyles);

  const endPoint = useMemo(() => {
    let ep = 'resources/attachment/upload';
    if (endPointFromProps) {
      ep = endPointFromProps;

      if (!excludeId && connectedForm) {
        ep += `/${connectedForm.getValues?.().id}`;
      }
    }
    return ep;
  }, [connectedForm, endPointFromProps, excludeId]);

  const fileSelectorRef = useRef<any>();

  const [uploading, setUploading] = useState(false);

  const dispatch = useDispatch<any>();

  const handleFileSelect = (event: any) => {
    event.preventDefault();
    handleFileUpload(event.target.files[0]);
  };

  const handleFileUpload = (file: Blob) => {
    setUploading(true);

    const formData = new FormData();
    formData.append('file', file);

    dispatch(appActions.uploadFile(formData, endPoint))
      .then((response: any) => {
        if (response.error) {
          dispatch(serviceActions.genericAlert('An error occurred', response.error, AlertType.Warning));
        } else if (response.response && response.response.message === 'Upload successful') {
          onBlur(response.response.filename);
        }
      })
      .finally(() => {
        setUploading(false);
      });
  };

  const handleFileRemoval = (event: any) => {
    event.preventDefault();
    onBlur('');
  };

  const handleEditClick = () => {
    const clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: false,
      cancelable: false,
    });
    fileSelectorRef.current?.dispatchEvent(clickEvent);
  };

  const renderRemoveOption = () => {
    if (value && value !== '' && !removeFileOption) {
      return (
        <div className={styles.removeLink} onClick={handleFileRemoval}>
          <span className="icon">delete</span>
          <span>Remove File</span>
        </div>
      );
    }
  };

  const renderIcon = () => {
    return (
      <>
        {uploading ? (
          <span className={styles.dropDownIcon}>
            <Icon path={mdiLoading} spin={true} size={0.75} color="#000" />
          </span>
        ) : (
          <span className={styles.dropDownIcon} onClick={handleEditClick}>
            <i className="icon">file_upload</i>
          </span>
        )}
      </>
    );
  };

  let styleName = '';
  let errorMessage: ReactNode = '';
  if (message !== undefined && message.length > 0) {
    styleName = 'invalid';
    errorMessage = <div className={styles.errorMessage}>{message[0].message}</div>;
  }

  let className = styles.selector;
  className += hiddenClass ? ` ${styles.hidden}` : '';

  const DropDownArea = <span className="dropdownArrow" onClick={handleEditClick} />;
  const icon = renderIcon();
  return (
    <div className={className}>
      <div className={`${styles.inputGroup} ${styles.selector} ${styles[styleName]}`}>
        <ValueField value={value} label={label} type="text" iconSuffix={true} data-testid={'file-selector-value'} />
        {DropDownArea}
        {icon}
        {errorMessage}
        <input type="file" onChange={(e) => handleFileSelect(e)} style={{ display: 'none' }} ref={fileSelectorRef} />
      </div>

      <div className={styles.inputGroup}>{renderRemoveOption()}</div>
    </div>
  );
};

export default FileSelector;
